<div class="text-center">
  <mat-icon>people_alt</mat-icon>
  <h1 *ngIf="_operator.id; else noUpdateTitle" mat-dialog-title translate> dialog.operator.update.title</h1>
  <ng-template #noUpdateTitle>
    <h1 mat-dialog-title translate>dialog.operator.create.title</h1>
  </ng-template>

  <div class="modal-body" mat-dialog-content>

    <help-alert 
    text        = "help.page.operator.field" 
    info        = "help.info"
    description = "help.page.operator.description"></help-alert>

    <div class="card container">
      <div class="row">
        <div class="col-sm">

          <mat-form-field class="full-width mt-3">
            <mat-label translate>dialog.operator.generic.userid</mat-label>
            <input [(ngModel)]="_operator.loginName" matInput>
          </mat-form-field>
      
        </div>
        <div class="col-sm">
      
          <mat-form-field class="full-width mt-3">

            <mat-label translate>dialog.operator.generic.level</mat-label>
      
            <mat-select [(ngModel)] = "_operator.authLevel" matNativeControl>
              <mat-option *ngFor="let level of levels" [value]="level.authLevel">
                {{level.authorization}}
              </mat-option>
            </mat-select>
      
          </mat-form-field>
          
        </div>
      </div>

    </div>

    <section class="mt-2">
      <mat-checkbox [(ngModel)]="_operator.enabled" class="example-margin">
        <text translate>dialog.operator.generic.enable</text>
      </mat-checkbox>
    </section>

  </div>

  <div class="modal-footer" mat-dialog-actions translate>
    
    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.operator.generic.cancel
    </button>

    <button *ngIf="_operator.id; else noUpdateConfirm" type="button" class="btn btn-outline-secondary" (click)="update()" translate>
      dialog.operator.update.confirm
    </button>
    
    <ng-template #noUpdateConfirm>
      <button type="button" class="btn btn-outline-secondary" (click)="create()" translate>
        dialog.operator.create.confirm
      </button>
    </ng-template>

  </div>